import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";

export default function FoodDeliveryFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [editingPost, setEditingPost] = useState(null);

  const handleEditPost = (post) => setEditingPost(post);
  const handlePostUpdated = (updatedPost) => {
    setPosts(prev => prev.map(p => p._id === updatedPost._id ? updatedPost : p));
    setEditingPost(null);
  };
  const handlePostDeleted = (postId) => {
    setPosts(prev => prev.filter(p => p._id !== postId));
  };

  const categories = [
    { id: "all", name: "Todos" },
    { id: "pizza", name: "Pizza" },
    { id: "burger", name: "Hambúrguer" },
    { id: "japanese", name: "Japonesa" },
    { id: "brazilian", name: "Brasileira" },
    { id: "healthy", name: "Saudável" },
    { id: "dessert", name: "Sobremesas" },
    { id: "vegan", name: "Vegano" },
  ];

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/food_delivery?page=${pageNum}&limit=16`;
      if (category !== "all") url += `&category=${category}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching food delivery:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [category]);

  if (loading && posts.length === 0) {
    return <div className="fooddelivery_feed_loading"><div className="fooddelivery_loader"></div><span>Carregando delícias...</span></div>;
  }

  return (
    <div className="fooddelivery_feed">
      {categories.length > 0 && (
        <div className="simple_filter_bar">
          <div className="filter_buttons">
            {categories.map((filter) => (
              <button
                key={filter.id}
                className={`filter_btn ${category === filter.id ? "active" : ""}`}
                onClick={() => setCategory(filter.id)}
              >
                {filter.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {posts.length === 0 ? (
        <div className="fooddelivery_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"/>
          </svg>
          <h3>Nenhum item encontrado</h3>
          <p>Seja o primeiro a cadastrar!</p>
        </div>
      ) : (
        <div className="fooddelivery_grid">
          {posts.map((post) => (
            <div key={post._id} className="fooddelivery_card">
              <div className="fooddelivery_image">
                <img src={post.foodDeliveryData?.image || post.images?.[0]?.url || post.images?.[0] || "/images/default-food.png"} alt="" />
                {post.foodDeliveryData?.discount && (
                  <span className="fooddelivery_discount">-{post.foodDeliveryData.discount}%</span>
                )}
              </div>
              <div className="fooddelivery_card_content">
                <div className="fooddelivery_restaurant">
                  <span>{post.foodDeliveryData?.restaurantName || "Restaurante"}</span>
                  {post.foodDeliveryData?.rating && (
                    <span className="fooddelivery_rating">⭐ {post.foodDeliveryData.rating.toFixed(1)}</span>
                  )}
                </div>
                <h3>{post.foodDeliveryData?.itemName || post.text}</h3>
                <p className="fooddelivery_description">{post.foodDeliveryData?.description}</p>
                <div className="fooddelivery_meta">
                  {post.foodDeliveryData?.preparationTime && (
                    <span className="fooddelivery_time">{post.foodDeliveryData.preparationTime} min</span>
                  )}
                  {post.foodDeliveryData?.deliveryFee > 0 ? (
                    <span className="fooddelivery_fee">Entrega R$ {post.foodDeliveryData.deliveryFee.toFixed(2)}</span>
                  ) : (
                    <span className="fooddelivery_free">Entrega Grátis</span>
                  )}
                </div>
                <div className="fooddelivery_footer">
                  <span className="fooddelivery_price">
                    R$ {(post.foodDeliveryData?.price || 0).toFixed(2)}
                  </span>
                  <button className="fooddelivery_add_btn">+ Adicionar</button>
                  <FeedPostMenu
                    post={post}
                    onEdit={handleEditPost}
                    onPostDeleted={handlePostDeleted}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="fooddelivery_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais"}
          </button>
        </div>
      )}

      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}
    </div>
  );
}
